import { RegistrationInfo } from '@widgets/registrationWizard/ui/RegistrationInfo/RegistrationInfo';
import { RegistrationDocs } from '@widgets/registrationWizard/ui/RegistrationDocs/RegistrationDocs';
import { RegistrationAccounts } from '@widgets/registrationWizard/ui/RegistrationAccounts/RegistrationAccounts';
import { RegistrationSignForm } from '@widgets/registrationWizard/ui/RegistrationSign/RegistrationSignForm';
import { ChangeUnionTypeAccountsStep } from '@widgets/registrationWizard/ui/ChangeUnionTypeAccounts';

export const wizardSteps = [
  {
    code: 'info',
    label: 'registration:info',
    Content: <RegistrationInfo />
  },
  {
    code: 'docs',
    label: 'registration:docs',
    Content: <RegistrationDocs />
  },
  {
    code: 'accounts',
    label: 'registration:accounts',
    Content: <RegistrationAccounts />
  },
  {
    code: 'sign',
    label: 'registration:accept',
    Content: <RegistrationSignForm />
  }
];

/**
 * Конфигурация шагов для ветки CHANGE_UNION_TYPE (смена формы управления).
 * Стандартный шаг «Счета» заменяется на ChangeUnionTypeAccountsStep.
 */
export const wizardStepsChangeUnionType = [
  {
    code: 'info',
    label: 'registration:info',
    Content: <RegistrationInfo />
  },
  {
    code: 'docs',
    label: 'registration:docs',
    Content: <RegistrationDocs />
  },
  {
    code: 'accounts',
    label: 'registration:accounts',
    Content: <ChangeUnionTypeAccountsStep />
  },
  {
    code: 'sign',
    label: 'registration:accept',
    Content: <RegistrationSignForm />
  }
];
